var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCareuser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1895 37.9393C33.1895 37.9393 32.5652 40.0516 30.4242 39.5271C28.2832 39.0025 23.2124 37.7816 23.2124 37.7816",
    stroke: "#132A3A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1895 37.9393C33.1895 37.9393 32.5652 40.0516 30.4242 39.5271C28.2832 39.0025 23.2124 37.7816 23.2124 37.7816",
    stroke: "#132A3A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4518 10.8373C34.1683 10.8373 36.3705 8.63512 36.3705 5.91863C36.3705 3.20215 34.1683 1 31.4518 1C28.7354 1 26.5332 3.20215 26.5332 5.91863C26.5332 8.63512 28.7354 10.8373 31.4518 10.8373Z",
    stroke: "#45B14A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7386 9.01589C45.7343 9.01589 47.3522 7.39804 47.3522 5.40232C47.3522 3.4066 45.7343 1.78874 43.7386 1.78874C41.7429 1.78874 40.125 3.4066 40.125 5.40232C40.125 7.39804 41.7429 9.01589 43.7386 9.01589Z",
    stroke: "#45B14A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1651 9.01589C21.1608 9.01589 22.7787 7.39804 22.7787 5.40232C22.7787 3.4066 21.1608 1.78874 19.1651 1.78874C17.1694 1.78874 15.5515 3.4066 15.5515 5.40232C15.5515 7.39804 17.1694 9.01589 19.1651 9.01589Z",
    stroke: "#45B14A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.061 9.01596H42.4169C40.2299 9.01596 38.3428 10.3642 37.5446 12.2703C39.1542 13.4765 40.2443 15.3404 40.4121 17.4535H48.9853C49.7334 17.4535 50.34 16.847 50.34 16.0988V14.295C50.3399 11.3914 47.9643 9.01596 45.061 9.01596ZM25.3595 12.2704C24.5613 10.3642 22.6743 9.01596 20.4872 9.01596H17.8431C14.9397 9.01596 12.5642 11.3914 12.5642 14.2949V16.0987C12.5642 16.847 13.1707 17.4535 13.919 17.4534H22.4921C22.6598 15.3404 23.7499 13.4765 25.3595 12.2704Z",
    stroke: "#132A3A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8799 24.166H38.5928C39.6112 24.166 40.4368 23.3404 40.4368 22.322V18.0227C40.4368 14.0707 37.2034 10.8373 33.2514 10.8373H29.6524C25.7005 10.8373 22.467 14.0707 22.467 18.0227V22.3219C22.467 23.3404 23.2925 24.1659 24.311 24.1659H29.4291M10.7343 46.8364L14.345 45.4656C16.9289 44.6234 19.6377 44.5382 21.8072 45.404L26.4144 47.2432C27.4214 47.5904 29.7349 48.1308 32.1355 46.9003L32.1375 46.8994L36.952 44.7697L40.108 43.3738L48.2214 39.785C48.7083 39.5353 51.157 38.0661 50.0599 35.5717C48.7883 32.9162 45.8615 34.1714 45.6158 34.2633L33.1898 37.9395C33.1898 37.9395 34.0405 35.4402 31.4645 34.4121C24.3253 31.5621 23.474 31.0802 21.6671 31.0515L21.667 31.0513C16.0817 31.0699 15.0697 31.1155 12.2941 32.3578C10.8477 33.0059 9.46692 33.7913 8.17072 34.7033C7.32539 35.2976 6.38738 35.7475 5.39111 36.0215L2.00061 36.9537C1.81073 37.006 1.64324 37.1191 1.52388 37.2757C1.40451 37.4323 1.33985 37.6238 1.33984 37.8207V49.1C1.33984 49.7293 1.96975 50.164 2.55815 49.9406L7.50828 48.0612",
    stroke: "#132A3A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareuser);
export default __webpack_public_path__ + "static/media/careuser.d7d51d91410794310b4d4096aeef8ece.svg";
export { ForwardRef as ReactComponent };